/**
 * Which market the tour opens (#776): an outcome whose Yes side has a live two-sided book (a mid strictly inside
 * (0, 1) in allMids), preferring prices away from the extremes so the book looks like a book. Falls back to any
 * listed outcome, or null when nothing is listed.
 */
import { outcomeMid } from '../hl/mids';
import type { AllMidsResponse } from '../hl/types';

export function pickTourMarket(
  outcomes: readonly { outcome: number }[],
  mids: AllMidsResponse | undefined,
): number | null {
  if (outcomes.length === 0) return null;
  let best: { outcome: number; score: number } | null = null;
  for (const o of outcomes) {
    const m = outcomeMid(mids, o.outcome, 0);
    if (m === undefined || !(m > 0 && m < 1)) continue;
    const score = Math.abs(m - 0.5); // closer to 50¢ = more interesting book
    if (!best || score < best.score) best = { outcome: o.outcome, score };
  }
  return best ? best.outcome : outcomes[0]!.outcome;
}
